__turbopack_context__.v({
  "case-study-hero": "CaseStudyHero-module-scss-module__9TYCcq__case-study-hero",
  "case-study-hero__category": "CaseStudyHero-module-scss-module__9TYCcq__case-study-hero__category",
  "case-study-hero__content": "CaseStudyHero-module-scss-module__9TYCcq__case-study-hero__content",
  "case-study-hero__link": "CaseStudyHero-module-scss-module__9TYCcq__case-study-hero__link",
  "case-study-hero__subtitle": "CaseStudyHero-module-scss-module__9TYCcq__case-study-hero__subtitle",
  "case-study-hero__title": "CaseStudyHero-module-scss-module__9TYCcq__case-study-hero__title",
  "floating": "CaseStudyHero-module-scss-module__9TYCcq__floating",
  "rotate": "CaseStudyHero-module-scss-module__9TYCcq__rotate",
});
